import { render } from "./ValueElement.vue?vue&type=template&id=21a44c03"
import script from "./ValueElement.vue?vue&type=script&lang=js"
export * from "./ValueElement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__